import axios from "./../../config/axios";

function all(customerId) {
    return axios().get("/sales-scheduling/sites", {
        params: {
            customer_id: customerId
        }
    })
}

export default {
    all
}